export default (state: any, {isSaving}: any) => ({
  ...state,
  businessProfile: {
    ...state.businessProfile,
    isSaving,
  },
});
